// extracted by mini-css-extract-plugin
module.exports = {"controlButton":"_2GUaI","hidden":"_1l1Z4","fullScreenControl":"_1X8gO","fullScreenToggle":"O7CH4","enterIcon":"_3Vnsh","exitIcon":"_2f-Eu","inFullScreen":"_2vy_-"};